import { useTranslation } from '../../lib/i18n'

export default function WatercoolerMessageNotification({ notification }) {
  const { t } = useTranslation()
  return (
    <>
      <p className="w-full max-w-200 md:max-w-300 line-clamp-2 overflow-hidden">
        <span className="text-off-black font-bold">
          {notification.notifiable?.user?.name}
        </span>{' '}
        {t('common.hasCreatedANewChatMessageIn')}{' '}
        <span className="text-off-black line-clamp-1 font-bold">
          {notification.notifiable?.postable_name}
        </span>
      </p>
      <p className="text-disabled line-clamp-2 break-word">
        {notification.notifiable?.snippet}
      </p>
    </>
  )
}
